import config from '../config/app'
import axios from 'axios'

const impactAPI = {
  update (impactId, data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'post',
        url: config.server + '/impact/' + impactId,
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  create (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/impact',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  remove (impactId, data = {}) {
    return new Promise((resolve, reject) => {
      axios.delete(config.server + '/impact/' + impactId, {data: data}).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  createBundleImpact (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/impact/bundle',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  },
  updateBundleImpact (data) {
    return new Promise((resolve, reject) => {
      axios.request({
        method: 'POST',
        url: config.server + '/impact/bundle/update',
        data: data
      }).then((response) => {
        resolve(response.data)
      }, (error) => {
        reject(error)
      })
    })
  }
}
export default impactAPI



// WEBPACK FOOTER //
// ./src/api/impact.js